import React from "react";

const Facebook = ({className}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 41.8" className={className}><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Layer_1-3" data-name="Layer 1"><path d="M42,21A21,21,0,1,0,17.7,41.8V27.1H12.4V21h5.3V16.3c0-5.3,3.1-8.2,7.9-8.2a33,33,0,0,1,4.7.4v5.2H27.7c-2.6,0-3.4,1.6-3.4,3.3v3.9h5.8L29.2,27H24.3V41.7A21.06,21.06,0,0,0,42,21Z"/></g></g></g></svg>
  )
}

export default Facebook;